import type { SVGProps } from 'react';

export const SearchIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M11 2.25C15.8325 2.25 19.75 6.16751 19.75 11C19.75 13.1462 18.9757 15.1106 17.6934 16.6328L21.5303 20.4697C21.8232 20.7626 21.8232 21.2374 21.5303 21.5303C21.2374 21.8232 20.7626 21.8232 20.4697 21.5303L16.6328 17.6934C15.1106 18.9757 13.1462 19.75 11 19.75C6.16751 19.75 2.25 15.8325 2.25 11C2.25 6.16751 6.16751 2.25 11 2.25ZM11 3.75C6.99593 3.75 3.75 6.99593 3.75 11C3.75 15.0041 6.99593 18.25 11 18.25C15.0041 18.25 18.25 15.0041 18.25 11C18.25 6.99593 15.0041 3.75 11 3.75Z" />
  </svg>
);
